import type { ComponentChildren, JSX } from "preact";
import { NavMenu } from "@gss/components/NavMenu";

export interface ResultTab {
    path: string | undefined;
    element: ComponentChildren;
    text: string;
}

interface TabsProps {
    basePath: string;
    activePath: string | undefined;
    tabs: ResultTab[];
}

export function ResultTabs({
    basePath,
    activePath,
    tabs,
}: TabsProps): JSX.Element {
    const foundActiveIndex = tabs.findIndex((tab) => tab.path === activePath);
    const activeIndex = foundActiveIndex !== -1 ? foundActiveIndex : 0;
    const nodes = tabs.map((tab) => ({
        path: tab.path != null ? `${basePath}/${tab.path}` : basePath,
        children: tab.text,
    }));

    return (
        <>
            <NavMenu variant="tabs" activeNode={nodes[activeIndex]}>
                {nodes}
            </NavMenu>

            <div className="pt-3" role="tabpanel">
                {tabs[activeIndex].element}
            </div>
        </>
    );
}
